import { useState, useEffect } from 'react';
import { apiFetch } from '../api';

export const useCenters = () => {
    const [centers, setCenters] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchCenters = async () => {
            const maxAttempts = 3;

            for (let attempt = 1; attempt <= maxAttempts; attempt += 1) {
                try {
                    const response = await apiFetch('/api/centers');
                    if (!response.ok) {
                        throw new Error('Failed to fetch centers');
                    }
                    const data = await response.json();
                    const centerOptions = data.map(center => ({
                        id: center.id,
                        label: center.name,
                        patients: center.patients
                    }));
                    setCenters(centerOptions);
                    setError(null);
                    setLoading(false);
                    return;
                } catch (err) {
                    if (attempt === maxAttempts) {
                        setError(err.message);
                        setLoading(false);
                        return;
                    }
                    await new Promise(resolve => setTimeout(resolve, 800));
                }
            }
        };

        fetchCenters();
    }, []);

    return { centers, loading, error };
}; 
